import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';

export const PRODUCTS_SETTINGS_ROUTE_NAMES = new Set<string>([
	ROUTE_NAMES.ARCHIVED_PLANS_DIRECTORY,
	ROUTE_NAMES.COMPASS_PRODUCT_SETTINGS,
	ROUTE_NAMES.CONFLUENCE_PRODUCT_SETTINGS,
	ROUTE_NAMES.EOC_ALERT_ISSUE_SYNCING,
	ROUTE_NAMES.EOC_API_KEY_MANAGEMENT,
	ROUTE_NAMES.EOC_ASSIGN_CUSTOM_ROLES,
	ROUTE_NAMES.EOC_CUSTOM_ROLES,
	ROUTE_NAMES.EOC_INCOMING_CALL,
	ROUTE_NAMES.EOC_INTEGRATIONS,
	ROUTE_NAMES.EOC_MAINTENANCE,
	ROUTE_NAMES.EOC_POLICIES,
	ROUTE_NAMES.EOC_ROLE_BASED_NOTIFICATIONS,
	ROUTE_NAMES.EOC_TEAM_CUSTOMER_LOGS,
	ROUTE_NAMES.EOC_UNLOCK_OPERATIONS,
	ROUTE_NAMES.GLOBAL_SETTINGS_PRODUCTS_APPLICATION_LINKS,
	ROUTE_NAMES.GLOBAL_SETTINGS_PRODUCTS_DVCS,
	ROUTE_NAMES.GLOBAL_SETTINGS_PRODUCTS_SDMAIL,
	ROUTE_NAMES.GLOBAL_SETTINGS_PRODUCTS_STATUS_PAGE,
	ROUTE_NAMES.POLARIS_SETTINGS_ACCESS,
	ROUTE_NAMES.POLARIS_SETTINGS_GLOBAL_FIELDS,
	ROUTE_NAMES.PRODUCTS_JSM_AUTHENTICATION_SETTINGS,
	ROUTE_NAMES.PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS,
	ROUTE_NAMES.PRODUCTS_JSM_COMPLIANCE,
	ROUTE_NAMES.PRODUCTS_JSM_CONFIGURATION,
	ROUTE_NAMES.PRODUCTS_JSM_CUSTOMER_ACCESS,
	ROUTE_NAMES.PRODUCTS_JSM_FEATURE_USAGE,
	ROUTE_NAMES.PRODUCTS_JSM_GLOBAL_OPS_REPORTS,
	ROUTE_NAMES.PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS,
	ROUTE_NAMES.PRODUCTS_JSM_KB_PERMISSIONS,
	ROUTE_NAMES.PRODUCTS_JSM_ORGANIZATIONS,
	ROUTE_NAMES.PRODUCTS_JSW_CONFIGURATION,
	ROUTE_NAMES.PRODUCTS_JSW_STORAGE_MANAGEMENT,
	ROUTE_NAMES.SOFTWARE_ARJ_SETTINGS_DEPENDENCIES,
	ROUTE_NAMES.SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR,
	ROUTE_NAMES.SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS,
	ROUTE_NAMES.SOFTWARE_ARJ_SETTINGS_PERMISSIONS,
	ROUTE_NAMES.TRASH_PLANS_DIRECTORY,
]);
